import Template from "@/App.vue";
import Navbar from "@/components/Navbar/Navbar.component";
import OverlayComponent from "@/components/sharedComponents/overlay/overlay.component";
import SessionAboutEndComponent from "@/components/sharedComponents/SessionAboutEnd/SessionAboutEnd.component";
import { ModalNotification, Notification } from "@/interfaces/notification";
import { EventBus } from "@/internal";
import { Callback } from "helix-vue-components";
import Fullscreen from "vue-fullscreen/src/component.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { RawLocation } from "vue-router";
import { Action, Getter } from "vuex-class";
import AlertComponent from "./components/sharedComponents/alert/alert.component";
import NotifyComponent from "./components/sharedComponents/notify/notify.component";
import { User } from "./interfaces/user";

Component.registerHooks(["onIdle"]);
@Component({
  mixins: [Template],
  components: {
    navbar: Navbar,
    Fullscreen,
    NotifyComponent,
    OverlayComponent
  }
})
export default class App extends Vue {
  @Getter("user", { namespace: "authModule" })
  public user!: User;
  @Getter("isLogged", { namespace: "authModule" })
  public isLogged!: boolean;
  public notify: boolean = false;
  public notifyParams: Notification = { text: "", color: "primary" };
  public currentPath: string = "/";
  public fullscreen: boolean = false;
  protected tokenInterval!: number;
  protected idleModalOpened: boolean = false;

  @Action("checkToken", { namespace: "authModule" })
  protected expAction!: Callback;
  @Action("registerApp", { namespace: "authModule" })
  protected registerApp!: Callback;
  @Action("unregisterApp", { namespace: "authModule" })
  protected unregisterApp!: Callback;

  public changeFullScreen() {
    // @ts-ignore
    this.$refs.fullscreen.toggle();
  }

  public showModal(msgModal: ModalNotification): void {
    this.$modals.load(
      AlertComponent,
      {
        size: "small"
      },
      {
        msgModal
      }
    );
  }

  public async onIdle() {
    if (!this.isLogged || this.idleModalOpened) {
      return;
    }
    this.idleModalOpened = true;
    try {
      await this.$modals.load(
        SessionAboutEndComponent,
        {
          size: "normal",
          positionY: "center",
          closable: false
        },
        {
          aboutEndTimeout: process.env.VUE_APP_SESSION_ABOUT_END
        }
      );
    } catch (e) {
      // Nothing to do
    }

    this.idleModalOpened = false;
  }

  @Watch("$route.path", { immediate: true })
  public changeRoute(path: string): void {
    this.currentPath = path;
  }

  protected mounted(): void {
    this.$i18n.locale =
      (this.user && this.user.settings && this.user.settings.locale) || "en";
    EventBus.$on("modal", this.showModal);
    EventBus.$on("route", (route: RawLocation) => this.$router.push(route));
    this.tokenInterval = setInterval(this.expAction, 30000);
    this.registerApp();
    window.addEventListener("beforeunload", this.unregisterApp);
  }
}
